module.exports = __webpack_public_path__ + "static/media/default.cd6d11ef.png";